import Icon from "@expo/vector-icons/MaterialCommunityIcons";
import { isWeb } from "@memorang/helpers/src/common";
import type { IconType } from "@memorang/ui/src/types";
import { useAppTheme } from "@memorang/ui/src/useAppTheme";
import { useState } from "react";
import { Pressable, TouchableOpacity } from "react-native";
import { Text } from "react-native-paper";
import Box from "../Box";
export type FollowUpMessageProps = {
	message: string;
	icon?: IconType;
	onPress: () => void;
	type?: "starterMessage" | "default";
};
const FollowUpMessage = ({
	message,
	icon,
	onPress,
	type = "default",
}: FollowUpMessageProps) => {
	const [opacity, setOpacity] = useState(1);
	const theme = useAppTheme();
	return (
		<>
			{message !== "" && (
				<Pressable
					onPress={onPress}
					onPressIn={() => setOpacity(0.5)}
					onPressOut={() => setOpacity(1)}
				>
					{(state) => {
						const hovered = "hovered" in state ? state.hovered : false;
						return (
							<Box
								gap={8}
								paddingHorizontal={16}
								backgroundColor={
									hovered ? theme.colors.inverseOnSurface : "transparent"
								}
								borderWidth={1}
								borderColor={theme.colors.secondaryContainer}
								paddingVertical={8}
								style={{
									opacity: opacity,
									borderRadius: type === "starterMessage" ? 100 : 20,
									borderBottomRightRadius: type === "starterMessage" ? 100 : 8,
								}}
								flexDirection={isWeb ? "row" : undefined}
								alignItems={type === "starterMessage" ? "center" : "flex-start"}
							>
								{icon && (
									<Icon
										name={icon as IconType}
										size={24}
										color={theme.colors.primary}
									/>
								)}
								<TouchableOpacity onPress={onPress} style={{ flex: 1 }}>
									<Text
										numberOfLines={0}
										variant="bodyMedium"
										style={{ flex: 1 }}
									>
										{message}
									</Text>
								</TouchableOpacity>
							</Box>
						);
					}}
				</Pressable>
			)}
		</>
	);
};

export default FollowUpMessage;
